<template>
  <div id="app">
    <!--顶部-->
    <Headers></Headers>
    <router-view></router-view>
	  <!--底部-->
	  <Footer v-show="$route.meta.footshow"></Footer>
  </div>
</template>
<script>
import Headers from "./components/common/header";
import Footer from "./components/common/footer";
export default {
  components: {
    Headers,
    Footer,
  }
};

</script>